/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { bannerControllerCreate } from '../fn/banner/banner-controller-create';
import { BannerControllerCreate$Params } from '../fn/banner/banner-controller-create';
import { bannerControllerDelete } from '../fn/banner/banner-controller-delete';
import { BannerControllerDelete$Params } from '../fn/banner/banner-controller-delete';
import { bannerControllerFindAll } from '../fn/banner/banner-controller-find-all';
import { BannerControllerFindAll$Params } from '../fn/banner/banner-controller-find-all';
import { bannerControllerFindById } from '../fn/banner/banner-controller-find-by-id';
import { BannerControllerFindById$Params } from '../fn/banner/banner-controller-find-by-id';
import { bannerControllerReorder } from '../fn/banner/banner-controller-reorder';
import { BannerControllerReorder$Params } from '../fn/banner/banner-controller-reorder';
import { bannerControllerSearchCursor } from '../fn/banner/banner-controller-search-cursor';
import { BannerControllerSearchCursor$Params } from '../fn/banner/banner-controller-search-cursor';
import { bannerControllerSearchOffset } from '../fn/banner/banner-controller-search-offset';
import { BannerControllerSearchOffset$Params } from '../fn/banner/banner-controller-search-offset';
import { bannerControllerUpdate } from '../fn/banner/banner-controller-update';
import { BannerControllerUpdate$Params } from '../fn/banner/banner-controller-update';
import { BannerDto } from '../models/banner-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class BannerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `bannerControllerFindAll()` */
  static readonly BannerControllerFindAllPath = '/api/banner';

  /**
   * 배너 전체 조회.
   *
   * 배너 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindAll$Response(params?: BannerControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BannerDto>>> {
    const obs = bannerControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 전체 조회.
   *
   * 배너 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindAll(params?: BannerControllerFindAll$Params, context?: HttpContext): Observable<Array<BannerDto>> {
    const resp = this.bannerControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<BannerDto>>): Array<BannerDto> => r.body)
    );
  }

  /** Path part for operation `bannerControllerCreate()` */
  static readonly BannerControllerCreatePath = '/api/banner';

  /**
   * 배너 생성.
   *
   * 배너을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerCreate$Response(params: BannerControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    const obs = bannerControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 생성.
   *
   * 배너을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerCreate(params: BannerControllerCreate$Params, context?: HttpContext): Observable<BannerDto> {
    const resp = this.bannerControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerControllerSearchOffset()` */
  static readonly BannerControllerSearchOffsetPath = '/api/banner/search/offset';

  /**
   * 배너 오프셋 기반 조회.
   *
   * 배너을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerSearchOffset$Response(params: BannerControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<BannerDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = bannerControllerSearchOffset(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 오프셋 기반 조회.
   *
   * 배너을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerSearchOffset(params: BannerControllerSearchOffset$Params, context?: HttpContext): Observable<{
'items': Array<BannerDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.bannerControllerSearchOffset$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<BannerDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<BannerDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `bannerControllerSearchCursor()` */
  static readonly BannerControllerSearchCursorPath = '/api/banner/search/cursor';

  /**
   * 배너 커서 기반 조회.
   *
   * 배너을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerSearchCursor$Response(params: BannerControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<BannerDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>> {
    const obs = bannerControllerSearchCursor(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 커서 기반 조회.
   *
   * 배너을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerSearchCursor(params: BannerControllerSearchCursor$Params, context?: HttpContext): Observable<{
'items': Array<BannerDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}> {
    const resp = this.bannerControllerSearchCursor$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<BannerDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>): {
'items': Array<BannerDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
} => r.body)
    );
  }

  /** Path part for operation `bannerControllerFindById()` */
  static readonly BannerControllerFindByIdPath = '/api/banner/{id}';

  /**
   * 배너 ID 기반 조회.
   *
   * 배너을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindById$Response(params: BannerControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    const obs = bannerControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 ID 기반 조회.
   *
   * 배너을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerFindById(params: BannerControllerFindById$Params, context?: HttpContext): Observable<BannerDto> {
    const resp = this.bannerControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerControllerDelete()` */
  static readonly BannerControllerDeletePath = '/api/banner/{id}';

  /**
   * 배너 삭제.
   *
   * 배너을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerDelete$Response(params: BannerControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    const obs = bannerControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 삭제.
   *
   * 배너을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerControllerDelete(params: BannerControllerDelete$Params, context?: HttpContext): Observable<BannerDto> {
    const resp = this.bannerControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerControllerUpdate()` */
  static readonly BannerControllerUpdatePath = '/api/banner/{id}';

  /**
   * 배너 수정.
   *
   * 배너을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerUpdate$Response(params: BannerControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    const obs = bannerControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 수정.
   *
   * 배너을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerUpdate(params: BannerControllerUpdate$Params, context?: HttpContext): Observable<BannerDto> {
    const resp = this.bannerControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerControllerReorder()` */
  static readonly BannerControllerReorderPath = '/api/banner/reorder';

  /**
   * 배너 순서 변경.
   *
   * 배너의 순서를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerControllerReorder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerReorder$Response(params: BannerControllerReorder$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BannerDto>>> {
    const obs = bannerControllerReorder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 순서 변경.
   *
   * 배너의 순서를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerControllerReorder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerControllerReorder(params: BannerControllerReorder$Params, context?: HttpContext): Observable<Array<BannerDto>> {
    const resp = this.bannerControllerReorder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<BannerDto>>): Array<BannerDto> => r.body)
    );
  }

}
